<template>
    <split-modal modal-id="combo-items-container" :actions="{addComboItemCart, emptyComboSelection}">
        <template v-slot:header>
            <button type="button" class="d-sm-none btn btn-arrow" data-dismiss="modal">
                <img src="/images/svg/global/left_arrow.svg" />
            </button>
            <h4 class="modal-title">{{  _T_DB(comboItemsList, 'name') || _T('Combo item') }}</h4>
        </template>
        <template v-slot:modal-body-1>
            <Item />
        </template>
        <template v-slot:modal-body-2>
            <ItemContent />
        </template>
        <template v-slot:footer>
            <b v-if="errorMessage.length" variant="danger"><a href="#" class="alert-link">{{ errorMessage }}</a></b>
            <b-button size="sm" class="btn-solid" @click="addComboItemCart()">
                {{ _T('Add to Order') }}
            </b-button>
            <b-button size="sm" class="btn-outline" @click="emptyComboSelection()">
                {{ _T('Cancel') }}
            </b-button>
        </template>
    </split-modal>
</template>

<script>
import SplitModal from '@/components/Modals/SplitModal'
import Item from './item'
import ItemContent from './ItemContent'
import {mapActions, mapGetters, mapState} from 'vuex'
export default {
    name: 'comboBox',
    components: {
        SplitModal,
        Item,
        ItemContent,
    },
    computed: {
        ...mapGetters(['_T', '_T_DB']),
        ...mapState('combo_items_store', [
            'comboItemsList',
            'activeComboItems',
            'setModifiersItem',
            'forCombo',
            'errorMessage',
        ]),
        ...mapGetters('combo_items_store', ['totalItemQty']),
        ...mapGetters(['cart_items_count']),
    },
    data() {
        return {
            comboItem: [],
            error: false,
            // dismissSecs: 5,
            // dismissCountDown: 0
        }
    },
    methods: {
        /*countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },*/
        ...mapActions(['addItemToCart']),
        addComboItemCart() {
            this.$store.commit('combo_items_store/SET_ERROR_MESSAGE', '')
            let activeItemModifiers = []
            // this.validateNumberOfItems()
            let itemQty = 0
            if (Object.values(this.activeComboItems).length === 0) {
                this.error = `Please select ${this.totalItemQty - itemQty} more item${
                    this.totalItemQty - itemQty > 1 ? 's' : ''
                }`
                this.$store.commit('combo_items_store/SET_ERROR_MESSAGE', this.error)
                return false
            }
            this.error = false
            // eslint-disable-next-line no-unused-vars
            for (let [key, value] of Object.entries(this.activeComboItems)) {
                value.map(activeItem => {
                    let activeChecker = this.setModifiersItem.find(
                        mItem => mItem._id === activeItem._id
                    )
                    if (activeChecker) {
                        itemQty += activeChecker.quantity ? parseInt(activeChecker.quantity) : 1
                        let item = this.updateItemPrice(activeChecker)
                        activeItemModifiers.push(item)
                    } else {
                        itemQty += 1
                        let item = this.updateItemPrice(activeItem)
                        activeItemModifiers.push(item)
                    }
                })
            }
            if (this.totalItemQty > itemQty) {
                this.error = `Please select ${this.totalItemQty - itemQty} more item${
                    this.totalItemQty - itemQty > 1 ? 's' : ''
                }`
            } else if (this.totalItemQty < itemQty) {
                this.error = `Please remove any ${itemQty - this.totalItemQty} item${
                    itemQty - this.totalItemQty > 1 ? 's' : ''
                }`
            } else {
                this.error = false
            }
            if (this.error) {
                this.$store.commit('combo_items_store/SET_ERROR_MESSAGE', this.error)
            }
            this.$store.dispatch(
                'combo_items_store/setAdditionalComboPrice',
                activeItemModifiers
            )
            let itemPriceSettlement = this.$store.getters[
                'combo_items_store/priceSettlement'
                ](activeItemModifiers)
            /*let data = []
            activeItemModifiers.forEach(item => {
                data.push(item)
            })*/
            if (!this.error) {
                let item = {
                    ...this.comboItemsList,
                    combo_selected_items: itemPriceSettlement,
                }
                // eslint-disable-next-line no-console
                console.log(item, 'filtered data', itemPriceSettlement)
                this.addItemToCart(item)
                this.$store.commit('combo_items_store/ACTIVE_COMBO_ITEMS', {}, { root: true })
                this.$bvModal.hide('combo-items-container')
            }
        },
        emptyComboSelection() {
            this.comboItem[this.comboItemsList] = false
            this.$store.commit('combo_items_store/ACTIVE_COMBO_ITEMS', false)
            this.$bvModal.hide('combo-items-container')
        },
        updateItemPrice(addedItem) {
            this.$store.dispatch('combo_items_store/updateOrderIndex')
            /*let totalItemInCart =
              parseInt(this.$store.getters['order/orderIndex']) || 1*/
            this.$store.commit(
                'combo_items_store/SET_FOR_COMBO',
                this.cart_items_count,
                {
                    root: true,
                }
            )
            return this.$store.getters['combo_items_store/updateItemPriceTax'](addedItem)
        },
    }
}
</script>

<style scoped lang="scss">
    #combo-items-container___BV_modal_body_ {
        display: grid;
        align-items: self-start;
        grid-template-columns: 1fr 3fr;
        padding: $px25 0px;
    }
</style>
